import { RotateCcw } from "lucide-react";

/** Fecha límite de pago de la factura (mig 083).
 *
 *  El contrato marco no fija el plazo: su cláusula 7 remite a cada Orden de
 *  Compra. Con el plazo capturado en el contrato, el backend precalcula la
 *  fecha contando desde el ÚLTIMO DÍA DEL PERIODO facturado; aquí se puede
 *  corregir antes de guardar (p. ej. si la factura se emitió otro día).
 */
export default function FechaLimitePago({
  valor,
  onChange,
  sugerida,
  plazoDias,
  plazoHabiles = true,
  hasta,
  etiqueta = "Fecha límite de pago",
  valorPrevio,
  onChangePrevio,
  etiquetaPrevio = "Fecha límite — preliminar",
}: {
  valor: string;
  onChange: (v: string) => void;
  sugerida?: string | null;
  plazoDias?: number | null;
  plazoHabiles?: boolean;
  hasta?: string;
  /** Etiqueta del campo principal (en un ajuste por gas, el del ajuste). */
  etiqueta?: string;
  /** Segundo campo: vencimiento de la factura PRELIMINAR que se está
   *  ajustando (prepago_gas, mig 084). Si no se pasa, no se pinta. */
  valorPrevio?: string;
  onChangePrevio?: (v: string) => void;
  etiquetaPrevio?: string;
}) {
  const fecha = (iso?: string | null) =>
    iso
      ? new Date(`${iso}T12:00:00`).toLocaleDateString("es-MX", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })
      : "—";
  const cambiada = !!sugerida && valor !== sugerida;

  return (
    <div className="bg-white border rounded-lg p-4">
      <div className="flex flex-wrap items-end gap-3">
        {onChangePrevio && (
          <label className="block">
            <span className="text-xs font-medium text-slate-600">{etiquetaPrevio}</span>
            <input
              type="date"
              className="mt-1 border rounded px-2 py-1.5 text-sm"
              value={valorPrevio ?? ""}
              onChange={(e) => onChangePrevio(e.target.value)}
            />
          </label>
        )}
        <label className="block">
          <span className="text-xs font-medium text-slate-600">{etiqueta}</span>
          <input
            type="date"
            className="mt-1 border rounded px-2 py-1.5 text-sm"
            value={valor}
            onChange={(e) => onChange(e.target.value)}
          />
        </label>
        {cambiada && (
          <button
            type="button"
            onClick={() => onChange(sugerida!)}
            title={`Volver a la precalculada (${fecha(sugerida)})`}
            className="inline-flex items-center gap-1 border rounded px-2.5 py-1.5 text-xs text-slate-600 hover:bg-slate-50"
          >
            <RotateCcw className="w-3.5 h-3.5" /> Restaurar
          </button>
        )}
        <span className="text-xs text-slate-500 pb-1.5">
          {plazoDias != null ? (
            <>
              Plazo de la OC: <b>{plazoDias} {plazoHabiles ? "Días Hábiles" : "Días naturales"}</b>{" "}
              contados desde el fin del periodo facturado ({fecha(hasta)}){" "}
              {cambiada ? (
                <>— precalculada: {fecha(sugerida)}, modificada a mano.</>
              ) : (
                <>— se guarda con la factura.</>
              )}
              {onChangePrevio && (
                <> La preliminar y el ajuste son dos documentos: cada uno se cobra
                  con su propia fecha.</>
              )}
            </>
          ) : (
            <>
              Este contrato no tiene plazo capturado (su OC pactó fechas límite fijas):
              captura la fecha a mano, o registra el plazo en <b>Contratos</b> para que se
              precalcule.
            </>
          )}
        </span>
      </div>
    </div>
  );
}
